import React from "react";
import loading from "@assets/img/loading.svg";

export default function Loading() {
    return (
        <object type="image/svg+xml" data={loading}/>
    );
}
